import type { AudioMixControlDraft, FinalVideoPlaybackSource, StoryboardWorkspaceState, UploadedWorkspaceVideo } from './types'

export const DEFAULT_AUDIO_MIX_CONTROLS: AudioMixControlDraft = {
  keep_original_audio: true,
  narration_volume: 1,
  bgm_volume: 0.24,
  original_audio_volume: 0.72,
  ducking_enabled: true,
}

function clampMixVolume(value: unknown, fallback: number) {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) {
    return fallback
  }
  return Math.min(1.5, Math.max(0, Number(numeric.toFixed(2))))
}

export function normalizeAudioMixControls(value?: Partial<AudioMixControlDraft> | null): AudioMixControlDraft {
  return {
    keep_original_audio: value?.keep_original_audio ?? DEFAULT_AUDIO_MIX_CONTROLS.keep_original_audio,
    narration_volume: clampMixVolume(value?.narration_volume, DEFAULT_AUDIO_MIX_CONTROLS.narration_volume),
    bgm_volume: clampMixVolume(value?.bgm_volume, DEFAULT_AUDIO_MIX_CONTROLS.bgm_volume),
    original_audio_volume: clampMixVolume(value?.original_audio_volume, DEFAULT_AUDIO_MIX_CONTROLS.original_audio_volume),
    ducking_enabled: value?.ducking_enabled ?? DEFAULT_AUDIO_MIX_CONTROLS.ducking_enabled,
  }
}

export function resolveLegacyAudioMixPreviewVideo(finalDelivery?: StoryboardWorkspaceState['final_delivery']): UploadedWorkspaceVideo | null {
  return finalDelivery?.audio_mix_preview_video || finalDelivery?.mixed_final_video || null
}

export function resolvePreferredFinalVideoSource(finalDelivery?: StoryboardWorkspaceState['final_delivery']): FinalVideoPlaybackSource {
  const source = String(finalDelivery?.preferred_final_video_source || '').trim()
  if (source === 'audio_mix_delivery' || source === 'uploaded_final' || source === 'system') {
    return source
  }
  return 'system'
}